import React, {MouseEvent} from 'react';
import {ContextMenu, ContextMenuItem} from '@priority-software/priority-style-react';
import {isRTL} from '../../../../Localization';
import {texts} from '../AdvancedSearch/AdvancedSearchDrawer/texts';

type Props = {
    clearFile: (e: MouseEvent<HTMLElement>) => Promise<void>;
    openImage: (e: MouseEvent<HTMLElement>) => Promise<void>;
    selectImage: (e: MouseEvent<HTMLElement>) => Promise<void>;
};

export const useContextMenu = (props: Props) => {
    const {clearFile, openImage, selectImage} = props;
    const [isOpenCtxMenu, setOpenCtxMenu] = React.useState(false);
    const [ctxMenuPosition, setCtxMenuPosition] = React.useState({top: 0, left: 0});
    const rtl = isRTL();

    const onContextMenuOpen = (e: MouseEvent) => {
        e.preventDefault();
        setCtxMenuPosition({top: e.clientY - 12, left: e.clientX + 24});
        setOpenCtxMenu(true);
    };

    const onContextMenuClose = () => {
        setCtxMenuPosition({top: 0, left: 0});
        setOpenCtxMenu(false);
    };

    const menuClick = (action: (e: MouseEvent<HTMLElement>) => void) => {
        return (e?: MouseEvent<HTMLElement>) => {
            e?.stopPropagation();
            onContextMenuClose();
            action(e);
        };
    };

    const renderCtxMenu = () => {
        return (
            <ContextMenu
                dropdownStyle={{position: 'fixed', ...ctxMenuPosition, width: 240, zIndex: 9999}}
                isOpen={isOpenCtxMenu}
                onClose={() => setOpenCtxMenu(false)}
                isRTL={rtl}
            >
                <ContextMenuItem isRTL={rtl} onClick={menuClick(openImage)}>
                    {texts.imgCtxOpen}
                </ContextMenuItem>
                {/*<ContextMenuItem isRTL={rtl}>{texts.imgCtxSaveAs}</ContextMenuItem>*/}
                {/*<ContextMenuItem isRTL={rtl}>{texts.imgCtxCopyLink}</ContextMenuItem>*/}
                {/*<ContextMenuItem isRTL={rtl}>{texts.imgCtxDuplicate}</ContextMenuItem>*/}
                <ContextMenuItem isRTL={rtl} onClick={menuClick(selectImage)}>
                    {texts.imgCtxImport}
                </ContextMenuItem>
                <ContextMenuItem isRTL={rtl} onClick={menuClick(clearFile)}>
                    {texts.imgCtxClear}
                </ContextMenuItem>
            </ContextMenu>
        );
    };

    return {
        isOpenCtxMenu,
        onContextMenuOpen,
        onContextMenuClose,
        renderCtxMenu
    };
};
